import { createFileRoute } from '@tanstack/react-router'

import { TeamPage } from '#/modules/teams/team-page'

export const Route = createFileRoute('/_shell/teams/$teamId')({
  component: function TeamRoute() {
    const { teamId } = Route.useParams()
    return <TeamPage teamId={teamId} />
  },
})
